import { Animated, Platform, Easing } from 'react-native';
export const getPostion = position => {
  switch (position) {
    case 'top-left':
      return {
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      };
    case 'top':
      return {
        justifyContent: 'center',
        alignItems: 'flex-start'
      };
    case 'top-right':
      return {
        justifyContent: 'flex-end',
        alignItems: 'flex-start'
      };
    case 'left':
      return {
        justifyContent: 'flex-start',
        alignItems: 'center'
      };
    case 'center':
      return {
        justifyContent: 'center',
        alignItems: 'center'
      };
    case 'right':
      return {
        justifyContent: 'flex-end',
        alignItems: 'center'
      };
    case 'bottom-left':
      return {
        justifyContent: 'flex-start',
        alignItems: 'flex-end'
      };
    case 'bottom':
      return {
        justifyContent: 'center',
        alignItems: 'flex-end'
      };
    case 'bottom-right':
      return {
        justifyContent: 'flex-end',
        alignItems: 'flex-end'
      };
  }
};
export const animatedTo = argus => {
  var _Animated$timing, _Animated$timing$star;
  const {
    target,
    toValue,
    duration,
    fn
  } = argus;
  (_Animated$timing = Animated.timing(target, {
    toValue,
    duration,
    useNativeDriver: Platform.OS !== 'web',
    easing: Easing.in(Easing.linear)
  })) === null || _Animated$timing === void 0 ? void 0 : (_Animated$timing$star = _Animated$timing.start) === null || _Animated$timing$star === void 0 ? void 0 : _Animated$timing$star.call(_Animated$timing, ({
    finished
  }) => {
    if (finished) {
      fn && fn();
    }
  });
};
export const parseSideSpace = props => {
  var _sideSpace$toString, _sideSpace$toString$s, _sideSpace$toString$s2, _sideSpace$toString$s3;
  const {
    sideSpace,
    scalable
  } = props;
  const result = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  if (!sideSpace) {
    return result;
  }
  const arr = (_sideSpace$toString = sideSpace.toString()) === null || _sideSpace$toString === void 0 ? void 0 : (_sideSpace$toString$s = _sideSpace$toString.split) === null || _sideSpace$toString$s === void 0 ? void 0 : (_sideSpace$toString$s2 = _sideSpace$toString$s.call(_sideSpace$toString, ' ')) === null || _sideSpace$toString$s2 === void 0 ? void 0 : (_sideSpace$toString$s3 = _sideSpace$toString$s2.map) === null || _sideSpace$toString$s3 === void 0 ? void 0 : _sideSpace$toString$s3.call(_sideSpace$toString$s2, v => {
    let r = Number.parseInt(v, 10);
    return r;
  });
  switch (arr.length) {
    case 4:
      return {
        top: arr === null || arr === void 0 ? void 0 : arr[0],
        right: arr === null || arr === void 0 ? void 0 : arr[1],
        bottom: arr === null || arr === void 0 ? void 0 : arr[2],
        left: arr === null || arr === void 0 ? void 0 : arr[3]
      };
    case 3:
      return {
        top: arr === null || arr === void 0 ? void 0 : arr[0],
        right: arr === null || arr === void 0 ? void 0 : arr[1],
        bottom: arr === null || arr === void 0 ? void 0 : arr[2],
        left: arr === null || arr === void 0 ? void 0 : arr[1]
      };
    case 2:
      return {
        top: arr === null || arr === void 0 ? void 0 : arr[0],
        right: arr === null || arr === void 0 ? void 0 : arr[1],
        bottom: arr === null || arr === void 0 ? void 0 : arr[0],
        left: arr === null || arr === void 0 ? void 0 : arr[1]
      };
    case 1:
      return {
        top: arr === null || arr === void 0 ? void 0 : arr[0],
        right: arr === null || arr === void 0 ? void 0 : arr[0],
        bottom: arr === null || arr === void 0 ? void 0 : arr[0],
        left: arr === null || arr === void 0 ? void 0 : arr[0]
      };
    default:
      return result;
  }
};